import { NgModule } from '@angular/core';
import { GenOrderConfirmationModule } from "./order-confirmation/order-confirmation.module";
import { GenOrderDetailsModule } from "./order-details/order-details.module";

@NgModule({
  declarations: [],
  imports: [
    GenOrderConfirmationModule,
    GenOrderDetailsModule,
  ],
})
export class GenOrderModule { }
